import { render, staticRenderFns } from "./notifyMessage.vue?vue&type=template&id=f5508ed4&scoped=true"
import script from "./notifyMessage.vue?vue&type=script&lang=ts"
export * from "./notifyMessage.vue?vue&type=script&lang=ts"
import style0 from "./notifyMessage.vue?vue&type=style&index=0&id=f5508ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5508ed4",
  null
  
)

export default component.exports